import { render } from "./dashboardComponent.vue?vue&type=template&id=477da43c&scoped=true"
import script from "./dashboardComponent.vue?vue&type=script&lang=js"
export * from "./dashboardComponent.vue?vue&type=script&lang=js"

import "./dashboardComponent.vue?vue&type=style&index=0&id=477da43c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-477da43c"]])

export default __exports__